// extracted by mini-css-extract-plugin
export default {"root":"create-warehouse-step_root__ByS1Q","content":"create-warehouse-step_content__SQ7DT","actions":"create-warehouse-step_actions__LpOYl"};